// Empty Pitcher UI i18next instance
import { i18n } from '@beerntea/pitcher-ui';
// Pitcher UI translation files
import { enPui } from '@beerntea/pitcher-ui/locales';

i18n.addResourceBundle('en_US', 'pui', enPui);
i18n.changeLanguage('en_US');

export default i18n;
